<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addProductDelivery()">添加商品配送方式
          </el-button>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" v-model="searchForm.title" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="productName" label="商品">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                <div class="info">
                  <div class="name">{{ scope.row.productName }}</div>
                  <div class="price">￥{{ scope.row.productPrice }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="deliveryType" label="配送方式" width="150">
            <template slot-scope="scope">
              <span>{{ getShowDeliveryText(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="添加时间" width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" title="配送设置"
               :close-on-press-escape="false" width="40%">
      <el-form size="small" ref="form" :model="form" :rules="formRules" label-width="120px"
               v-loading="loading">
        <el-form-item label="商品名称：" prop="productId">
          <div class="table-wrap">
            <el-button @click="onProductChoose">选择商品</el-button>
            <el-table size="small" :data="form.tableData" border style="width: 100%;margin-top: 15px">
              <el-table-column prop="productName" label="商品名称">
                <template slot-scope="scope">
                  <div class="product-info">
                    <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                    <div class="info">
                      <div class="name">{{ scope.row.productName }}</div>
                      <div class="price">￥{{ scope.row.productPrice }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="配送方式：" prop="deliveryType">
          <el-radio-group v-model="form.deliveryType">
            <el-radio v-for="(item,index) in all_type" :label="item.value" :key="index">{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addClickOK">确 定</el-button>
      </div>
    </el-dialog>
    <getproduct :isProduct="open_product" :dataType="2" :islist="false" @closeDialog="closeDialogFunc($event)"/>

  </div>
</template>

<script>
import getproduct from '@/components/product/Product.vue'
import ProductApi from '@/api/product.js'

export default {
  name: 'index',
  components: {getproduct},
  data () {
    return {
      searchForm: {
        title: '',
      },
      open_product: false,
      loading: false,
      tableData: [],
      dialogVisible: false,
      form: {
        id: 0,
        productId: '',
        deliveryType: 10,
        tableData: []
      },
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      all_type: [{
        name: '快递',
        value: 10
      }, {
        name: '自提',
        value: 20
      }],
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getData()
    },
    addProductDelivery () {
      this.form = {
        id: 0,
        productId: '',
        deliveryType: 10,
        tableData: []
      }
      this.dialogVisible = true
    },
    onSubmit () {
      this.curPage = 1
      this.getData()
    },
    getData () {
      let self = this
      self.loading = true
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize

      ProductApi.deliverySettingList(Params, true).then(res => {
        self.loading = false
        self.tableData = res.data.records
        self.totalDataNumber = res.data.total
      }).catch(error => {
        self.loading = false
      })
    },
    editClick (row) {
      this.form = {
        id: row.id || 0,
        productId: row.productId || '',
        deliveryType: row.deliveryType,
        tableData: [{
          productId: row.productId || '',
          productName: row.productName || '',
          imagePath: row.imagePath || '',
          productPrice: row.productPrice || '',
        }]
      }
      this.dialogVisible = true
    },
    onProductChoose () {
      this.open_product = true
    },
    closeDialogFunc (e) {
      if (e.type !== 'error') {
        let params = e.params
        this.form.productId = params.productId
        this.$emit('change', this.form.productId)
        this.form.tableData = [params]
      }
      this.open_product = false
    },

    addClickOK () {
      let self = this
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = self.form
          ProductApi.addDeliverySetting(params, true)
            .then(res => {
              this.getData()
              this.dialogFormVisible()
            })
            .catch(error => {

            })

        }
      })
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },
    dialogFormVisible () {
      this.dialogVisible = false
    },
    delClick (row) {
      let self = this
      self.$confirm('删除后不可恢复，确认删除该商品配送方式?', '提示', {
        type: 'warning'
      }).then(() => {
        ProductApi.delDeliverySetting({
          id: row.id
        }, true).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          self.getData()
        })
      })
    },
    getShowDeliveryText (row) {
      let text = ''
      let item = this.all_type.find(e => {
        return e.value === row.deliveryType
      })
      if (item) {
        text = item.name || ''
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/activity/deliveryconfig/index.vue